import { useQuery } from '@tanstack/react-query'

import {
  assessmentListQueryOptions,
  type AssessmentListParams,
} from '@/features/assessments/api/assessment-list'

export function useAssessmentList(params: AssessmentListParams) {
  const { data, isPending, isError } = useQuery(assessmentListQueryOptions(params))
  return { data, isLoading: isPending, isError }
}
